import React from "react";
import { PageSkeleton } from "@/components/ui/page-skeletons";
import { cn } from "@/lib/utils";

const Loader = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        "w-full min-h-[40vh] flex items-start justify-center",
        className,
      )}
      role="status"
      aria-label="Loading"
    >
      <PageSkeleton />
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default Loader;
